import { apiClient } from '@/lib/api/client'
import {
  StListingTypes,
  StListingTypesInsert,
  StListingTypesUpdate,
} from '@/types'
import { IRepository } from './types'

class StListingTypesRepository
  implements
    IRepository<StListingTypes, StListingTypesInsert, StListingTypesUpdate>
{
  private static instance: StListingTypesRepository
  private readonly endpoint: string

  constructor(endpoint: string = 'stays-listing-types') {
    this.endpoint = endpoint
  }

  public static getInstance(): StListingTypesRepository {
    if (!this.instance) {
      this.instance = new StListingTypesRepository()
    }
    return this.instance
  }

  async getAll(_params?: unknown): Promise<StListingTypes[]> {
    return apiClient.invoke<StListingTypes[]>(this.endpoint, {
      method: 'GET',
    })
  }

  async getById(id: string): Promise<StListingTypes | null> {
    return apiClient.invoke<StListingTypes>(`${this.endpoint}?id=${id}`, {
      method: 'GET',
    })
  }
}

export const stListingTypesRepository = StListingTypesRepository.getInstance()
